import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormContainer from '../../components/form/FormContainer';
import CheckoutSteps from '../../components/checkout/CheckoutSteps';
import Meta from '../../components/layout/Meta';
import { Button, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { savePaymentMethod } from '../../slices/cartSlice';

const PaymentScreen = () => {
    const { userInfo } = useSelector((state) => state.auth);

    const cart = useSelector((state) => state.cart);
    const { shippingAddress } = cart;
    const [paymentMethod, setPaymentMethod] = useState(cart.paymentMethod || 'PayPhone');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!shippingAddress) {
            navigate('/shipping');
        }
    }, [shippingAddress, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();
        dispatch(savePaymentMethod(paymentMethod));
        navigate('/placeorder');
    };

    return (
        <FormContainer>
            <Meta title="Método de Pago" />
            <CheckoutSteps paymentScreen />
            <h1 style={{ marginTop: '1rem', textAlign: 'center' }}>{'Método de Pago'}</h1>
            <Form onSubmit={submitHandler}>
                <Form.Group>
                    <Form.Label as="legend" column='lg'>{'Seleccione el Método'}</Form.Label>
                    <Col>
                        <Form.Check
                            type="radio"
                            className="my-2"
                            label="PayPhone"
                            id="PayPhone"
                            name="paymentMethod"
                            value="PayPhone"
                            required={true}
                            defaultChecked={paymentMethod === 'PayPhone'}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        ></Form.Check>
                        <Form.Check
                            type="radio"
                            className="my-2"
                            id="Credit"
                            name="paymentMethod"
                            value="Credit"
                            required={true}
                            defaultChecked={paymentMethod === 'Credit'}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            hidden={userInfo?.priceAssigned !== 'pvp_distribuidor' || true}
                        >
                            {userInfo?.priceAssigned === 'pvp_distribuidor' && 'Crédito'}
                        </Form.Check>
                    </Col>
                </Form.Group>

                <Button
                    type="submit"
                    variant="primary"
                    className="my-2"
                    style={{ marginTop: '1rem', float: 'right' }}
                >
                    Continuar
                </Button>
            </Form>
        </FormContainer>
    );
};
export default PaymentScreen;
